var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contents"},[_c('div',{staticClass:"content",class:{'d3':_vm.isFireFox}},[_c('img',{staticClass:"img-thumbnail img-responsive",attrs:{"src":_vm.img,"alt":"图片"}}),_vm._v(" "),_c('div',{staticClass:"back-div"},[_c('p',{staticClass:"title",attrs:{"title":_vm.title},domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),_c('p',{staticClass:"detail",attrs:{"title":_vm.word},domProps:{"innerHTML":_vm._s(_vm.word)}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1724c5ad","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/ImgIntroducePanel.vue
// module id = 182
// module chunks = 0